export interface DetailRow {
  label: string;
  value: string;
  type?: string;
}

export interface DetailParams {
  rows: DetailRow[];
}

export interface DetailParamsList {
  rows: DetailParams[];
}

export interface DetailField {
  name: string;
  label: string;
  type?: string;
  format?: (v: any, ex?: any) => string;
}

export interface DetailFieldList {
  fields: DetailField[];
}

export const DetailFieldTypes = {
  text: 'text',
  number: 'number',
  attachment: 'attachment',
  onlyVal: 'only-val',
};
